module.exports = __webpack_public_path__ + "img/3.6ee09774.jpg";